import type { IDB, IDBCreate, IDBOptions, IDBStoreEngine } from './interface';

function _openIDB(name: string, options?: Partial<IDBOptions>): Promise<IDB> {
    return new Promise((resolve, reject) => {
        import('./idb')
            .then(idb => idb.default(name, options))
            .then((db: IDB) => {
                resolve(db);
            })
            .catch((err: Error) => {
                reject(err);
            });
    });
}

function _openMem(name: string, options?: Partial<IDBOptions>): Promise<IDB> {
    return new Promise((resolve, reject) => {
        import('./mem')
            .then(mem => mem.default(name, options))
            .then((db: IDB) => {
                resolve(db);
            })
            .catch((err: Error) => {
                reject(err);
            });
    });
}

const STORAGEENGINE: Record<
    IDBStoreEngine,
    (name: string, options?: Partial<IDBOptions>) => Promise<IDB>
> = {
    indexeddb: _openIDB,
    memory: _openMem,
};

const OPTIONS_DEFAULTS: IDBOptions = {
    version: 1,
    engine: 'memory',
    mappings: {},
};

let OPTIONS_OVERRIDES: Partial<IDBOptions> = {};

function _options(options?: Partial<IDBOptions>): IDBOptions {
    const isRunningOnNodeJS = typeof window === 'undefined';

    const optionsDB: IDBOptions = {
        ...OPTIONS_DEFAULTS,
        ...OPTIONS_OVERRIDES,
        ...options,
        engine:
            options?.engine ??
            OPTIONS_OVERRIDES.engine ??
            (isRunningOnNodeJS ? 'memory' : 'indexeddb'),
    };

    return optionsDB;
}

function _open(name: string, optionsIn?: Partial<IDBOptions>) {
    const options = _options(optionsIn);

    return STORAGEENGINE[options.engine](name, options);
}

async function _expand(data: string, name: string, optionsIn?: Partial<IDBOptions>): Promise<IDB> {
    const options = _options(optionsIn);

    const db = await STORAGEENGINE[options.engine](name, options);

    await db.apply(data);

    return db;
}

function DB(): IDBCreate {
    return {
        open: _open,
        expand: _expand,
        setDefaults: (options: Partial<IDBOptions>) => {
            OPTIONS_OVERRIDES = options;
        },
    };
}

export default DB;
